export default {
  button: {
    sendMail: "Sending mail",
    cancel: 'Cancel',
    confirm: 'Confirm',
    add: 'Add',
    settings: 'Settings',
    close: 'Close',
    delete: 'Delete',
    save: 'Save',
    edit: 'Update',
    view: 'Details',
    statistics: 'Statistics',
    infos: 'Live informations',
    export: 'Subscribers list',
    export_questions: 'Export questions',
    diffusion: 'Broadcast',
    comments: 'Comment list',
    encoding: 'Live station',
    done: 'done',
    link_export: 'export links',
    send_invitations: 'Send invitations',
    send_group_mails: 'Send group list',
    send: 'Send',
    share: 'Add screen share',
    validate: 'Validate',
    download: 'Download screen share file',
    show_live: 'Show live',
    ok: 'Ok',
    add_emails: 'Add emails',
    return: 'Return',
    copy: 'Copy',
    visualize: 'Visualize',
    restart: 'Restart',
    upload: 'Download',
    restore: 'Restore',
    flow: 'Flow'
  },
  parameters: {
    period: {
      period: 'Period',
      week: 'Week',
      month: 'Month',
      trimester: 'Trimester',
      semester: 'Semester',
      year: 'Year',
    },
    search: {
      title: 'Title',
      description: 'Description',
      search: "Search"
    },
    filter: {
      contributors: 'Contributors',
      date: 'Date',
      period: 'Period',
      search: 'Search',
      reset: 'Reset',
      no_options: 'Sorry, No matching options',
      no_contributor:'Sorry, No matching options:'
    },
    select: {
      selectOption: 'Select',

    },
  },
  table: {
    pagination: {
      first: 'First',
      last: 'Last',
      prev: 'Prev',
      next: 'Next',
      show: 'Show',
      elements: 'Elements',
      elementPerPage: "Elements per page"
    },
    list: {
      id: 'Id',
      preview: 'Preview',
      title: 'Title',
      description: 'Description',
      active: 'Active',
      statut:"Status",
      date: 'Date',
      actions: 'Actions',
      idInscrit: "ID",
      nom: "Name",
      email: "Email",
      entreprise: "Company",
      participation: "Participation",
      subscribersList: "List of registrants"
    },
    empty: 'Sorry, there is nothing to display here.',
  },

  modal: {
    send_email: "Send an email",
    groups: "Groups",
    hour: "Hour",
    date: "Date",
    users: "Users",
    moderators: "Moderators",
    select_groups: "Select groups",
    EnterEmails: "Enter emails and press Enter",
    about: 'About',
    error: 'Please check all fields',
    errorDuplicate: "The speaker has already been updated with the same information.",
    errorEmail: "Invalid email address",
    errorEmailDuplicated: "Email is already exist",
    errorUpload: "Error while uploading image",


    success: "A speaker has been successfully added",
    successUpdate: "A speaker has been successfully updated",
    delete: {
      selection: {
        title: 'Are you sure to delete its lives?',
        subtitle: 'Selected elements deleted.',
        confirm_title: 'Deleted',
        confirm_msg: 'Deleted successfully .',
        cancel_title: 'Cancel',
        cancel_msg: 'Delete canceled',
        btn_confirm: 'Delete',
        btn_cancel: 'Cancel',
      },
      form: {
        subtitle: 'Selected elements deleted.',
      },
      title: 'Are you sure to delete this live?',
      subtitle: ' was deleted.',
      confirm_title: 'Deleted',
      confirm_msg: 'Deleted successfully .',
      cancel_title: 'Cancel',
      cancel_msg: 'Delete canceled',
      btn_confirm: 'Delete',
      btn_cancel: 'Cancel',
    },
    edit: {
      title: 'Edit the title of this screen',
      error_msg: 'Enter a name',
      btn_confirm: 'Edit',
      btn_cancel: 'Cancel',
    },
    view: {
      title: 'Live detail ',
      btn_cancel: 'Close',
      params: {
        title: 'Title',
        id: 'ID',
        description: 'Description',
        tags: 'Tags',
        date: 'Date',
        private: 'Private',
        automatic_share: 'Automatic share',
        active: 'Active',
        vignette: 'Thumbnail',
        like: 'I like',
        poll: 'Poll',
        registration: 'Subscribers registration',
        send_mails: 'send comments',
        share_file: 'Shared files',
        screen_share: 'Screen share',
        config: 'Default configuration',
        yes: 'Yes',
        no: 'No',
      },
    },
    setting: {
      diffusion: {
        title: 'Stream',
        endless: 'Available',
        archived: 'Archived',
        all: 'All',
        upcoming: 'Upcoming',
        trash: 'trash',
      },
    },
    infos: {
      title: 'Broadcast settings ',
      btn_cancel: 'Close',
      url_diffusion: 'Stream',
      name_flow: 'Key of flow',
      login: 'Login',
      pass: 'Password',
      link: 'Link',
      key: 'Key'
    },
    export: {
      title: 'Export Links of live : ',
      permalink: 'Permalink',
      permalink_participant: 'Speaker URL',
      standAlone: 'Stand alone url',
      standAlone_permalink: 'Listener URL',
      standAlone_permalink_participant: 'Participant URL',
      embed: 'Embed link',
      moderator: 'Moderator link',
      journalist: 'Prompter link',
      url: 'Export url',
      copy: 'Copy',
    },
    send_invitations: {
      title: 'Send invitations',
    },
    send_group_mails: {
      title: 'Send group list',
      insert_mails: {
        title: 'Insert emails',
        placeholder: 'Emails',
        label: 'List of emails',
        text: 'Please insert the emails in the following field',
      },
      send_mails: {
        title: 'Send to customers',
        text: 'Select emails group from the list below',
        groupLabel: 'Group list',
        mailLabel: 'Emails list',
      },
    },
    screen_share: {
      title: 'Output type',
      type: 'Choose the output type',
    },
    show_archived_live: {
      title: 'Archived live',
      not_found: 'Live not found',
      not_transcripted: 'Live not encoded',
    },
    direct: {
      start: {
        title: "Start live",
        subtitle: "Do you want to start live?",
      },
      stop: {
        title: "Stop live",
        subtitle: "Do you want to stop live?",
      },
      archiving: {
        title: {
          simple: "Are you sure you want to put this direct in the trash?",
          multi: 'Are you sure you want to put these directs in the trash?',
        },
        subtitle: {
          simple: " will be placed in the trash",
          multi: " will be placed in the trash"
        },
        success: {
          simple: ' is placed in the trash',
          multi: ' are placed in the trash'
        }
      },
      restoring: {
        title: {
          simple: "Are you sure you want to restore this direct?",
          multi: 'Are you sure you want to restore these directs?',
        },
        subtitle: {
          simple: " will be restored",
          multi: " will be restored",
        },
        success: {
          simple: ' is restored',
          multi: ' are restored',
        }
      },
      deleting: {
        title: {
          simple: "Are you sure you want to permanently delete this direct?",
          multi: "Are you sure you want to permanently delete these directs?",
        },
        subtitle: {
          simple: " will be permanently deleted",
          multi: " will be permanently deleted",
        },
        success: {
          simple: ' is deleted',
          multi: ' are deleted'
        }
      },
      checked_elements: 'The selected elements',
      flow: 'Live preview'
    }
  },
  calendar: {
    title: 'Calendar',
    allDay: 'all-day',
    back: 'Return to list',
    statistics: 'Statistics',
    view: 'View',
    edit: 'Edit',
    period: {
      show: 'show as',
      week: 'Week',
      month: 'Month',
      day: 'Day',
      today: 'Today',
    },
    months: {
      january: 'january',
      february: 'february',
      march: 'march',
      april: 'april',
      may: 'may',
      june: 'june',
      july: 'july',
      august: 'august',
      september: 'september',
      october: 'october',
      november: 'november',
      december: 'december',
    },
  },
  form_live: {
    consent: {
      title: 'Video conference recording',
      noConsent: 'Without consent (default option)',
      withConsent: "With participants' consent",
    },
    tabs: {
      pick_video: 'Please choose a video',
      required_message: 'This field is required',
      error_long_message: 'Message must not exceed 255 characters',
      general: {
        title: 'General',
        form: {
          title: 'Title',
          description: 'Description',
          types:"Display type",
          type_default:"Default",
          add_image: 'Add thumbnail',
          description_image: 'Recommended image size: 1280 x 720',
          edit_image: 'Update',
          delete_image: 'Delete',
          start_date: 'Start date',
          end_date: 'End date',
          start_hour: 'Start hour',
          end_hour: 'End hour',
          tags: 'Tags',
          themes: 'Themes',
          invalid_date: 'Invalid date ',
          invalid_hour: 'Invalid hour',
          access_live: 'Direct access modes',
          access_free: 'Free access',
          access_secure: 'Secured access',
          placeholder_pass: 'enter your password',
          secure_pass: 'Generate a secure password',
          schedule_live: 'Schedule live',
          share_live: {
            title: 'Live sharing link',
            copy: 'Copy',
          },
          archived_live: 'Automatic live archivingt',
          duration: 'Durée',
          video: {
            visible: 'Visible',
            invisible: 'Invisible',
          },
          publish: 'Publishing rights',
          multimedia_options: 'Live multimedia options',
          interactives_options: {
            title: 'Live interactive options',
            social_media: {
              fb: 'Live broadcast on your Facebook page',
              youtube: 'Archiving the video on your Youtube channel',
            },
          },
          infos: {
            vignette: "cliquez sur l'icone pour modifier la vignette de votre vidéo",
            archived_live:
              'Your direct will be automatically archived and available for viewing on demand video',
            access_free:
              "Le direct sera visible sans mot de passe, ni autre procédure d'accès sécurisé)",
            access_secure:
              'Le direct sera accessible avec le mot de passe que vous saisissez ci-dessous',
            secure_pass: 'Un mot de passe sera généré pour chaque invitation par mail',
            share_live: 'Le lien comprend le titre de votre conférence',
            themes:
              "Le thème s'applique pour les vidéos à la demande, vous pouvez choisir un ou plusieurs thèmes",
            rich_media: "Cette option permet d'associer des images synchronisées avec la vidéo",
            attaching_files: "Cette option permet d'ajouter des documents téléchargeables",
            tags: "Les mots clés permettent d'améliorer le référencement des vidéos",
          },
        },
      },
      configuration: {
        title: 'Configuration',
        form: {
          infos_live: 'Information display before live',
          title_before_live: 'Title (posted on the live page)',
          title_live: 'Live title',
          description: 'Description text',
          text: 'Text',
          description_before_live: 'Description (posted on the live page)',
          text_before_live: 'Text before live',
          message: {
            title: 'Message',
            description: 'Description (posted on the live page)',
          },
          video: {
            title: 'Video',
            description: 'Search...',
          },
          image: 'Image',
          countdown: 'Countdown',
          skins_live: 'Selection of the template for the live page',
          more: 'Show all',
          less: 'Show less',
          contact: 'Contact',
          informations: 'Additional live information',
          about: 'About',
          intervenants: {
            title: 'Contributors',
            add: 'Add Contributor',
            firstName: 'FirstName',
            lastName: 'LastName',
            fonction: 'Fonction',
            email: 'E-mail',
            biography: 'Biography',
          },
          email: 'E-mail',
          phone: 'Phone',
          address: 'Address',
          send_invitations: {
            title: 'Sending live invitations',
            group_emails: 'Group',
            emails: 'E-mail',
          },
          send_rule: {
            title: 'Sending rule',
            days_left: 'Day (s) before the live at',
            add_rule_button: 'Add rule',
          },

          encoding: {
            title: 'Encoding options ',
            url: 'Direct stream url',
            name: 'Direct stream name',
            key: 'Security key (optional)',
          },
          infos: {
            skins_live: 'You can edit the templates in the "Web site" function',
            message: 'Text displayed before the live broadcast',
            video: 'Video displayed before the live broadcast',
            image: 'Image displayed before the live broadcast',
            about: 'Appears on the "About" link page',
            contact: 'Appears on the "Contact" link page',
            intervenants: 'Displayed in the live page (in the "Description" link',
            group_emails:
              'A group is a set of emails, groups can be edited in the "Email" function',
            send_rule: 'You can define one or more rules to send invitations by email',
            encoding: '\n' + 'This option applies if you are using an external encoder, see FAQ',
          },
        },
      },
      advanced: {
        title: 'Advanced parameters',
        type: {
          title: 'Live type',
          intranet: 'Intranet',
          internet: 'Internet',
        },
        diffusion: {
          type_source:"Live usage type",
          diffusion_social_media:"Sharing on social media",
          medias:"Medias",
          title_empreinte: 'Sources',
          webinar_empreinte: 'Empreinte Live',
          encodeur_empreinte:"Video Encoder",
          languages_empreinte:"Multilingual",
          ajoute_entree:"(add entry)",

          title: 'Stream',
          webinar: 'Live studio',
          encoding: 'Manual encoder',
          sharing: 'Screen sharing',
          externalHlst: "external Hls",
          encoder:"Encoder",
          protocol:"Protocol type",
          languages:"Languages",
          languagesPlaceholder:"Select languages",
          countries:"Countries",
          countriesPlaceholder:"Select countries",
          addyoutubeLanguage:"ADD THIS LANGUAGE",
          emptyInput: "Please enter a YouTube URL",
          select_station:"Choose a station",
          validUrl: "The YouTube URL entered is not valid",
          duplicateUrl: "This URL is already associated with another language",
           "language": {
           "orateur": "speaker",
           "FL1": "Floor Language",
           "FL2": "Floor Language 2",
           "Français": "French",
           "Anglais" : "English",
           "ES": "Spanish",
           "RU":"Russian",
           "AR":"Arabic",
           "ZH":"Chinese",
           "Autres": "Other"
           },
          encodeur_automatique:"Automatic encoder",
          index_audio_port:"Audio port index",
          index_video_port:"Video port index",
          screen_share: {
            pip: 'Picture in Picture PIP',
            sbs: 'Side by Side',
          },
          type: {
            title: "Webinar choice",
            title_empreinte: "Acces Empreinte Live",
            by_link_empreinte:"Individual private access",
            private_empreinte:"Private access",
            public_empreinte:"Public access",
            by_link: "Url per user",
            private: "Private",
            public: "Public"
          },
	          connexion: {
	            title: "Connection type",
	            title_empreinte:"Login",

	            auto: "Automatic",
	            auto_description: "Direct access (default)",
	            by_authorization: "With permission",
	            by_authorization_description: "Waiting room: Access after validation"
	          }
	        },
	        options: {
	          title: 'General options',
	          title_empreinte:"Video Options",
          private_video: 'Private video',
          active_video: 'Active video',
          automatic_share: 'Automatic sharing',
          saveVideo:"Save video"
        },
	        contributors: {
	          header :"Profiles",
	          participantTitle:'Participants',
            importMultiParticipants:"Select one or more email addresses, or import a CSV or Excel file.",
	          title: 'Administrators',
	          admin_description: "Conference manager with full control.",
	          participants_description: "Videoconference participants (limited rights).",
	          moderators_description: "Allowed to manage comments (chat, Q&A).",
	          select_item: 'Press enter to select',
	          selected_item: 'Selected',
	          delete_item: 'Press enter to delete',
	          no_result: 'No elements found. Consider changing the search query.',
	          no_options: 'List is empty..',
	          add_email:'Add this email',
	        },
        rich_media: {
          title: 'Rich Media',
          tabs: {
            chapters: {
              title: 'Chapters',
              empty: 'No Chapters',
              fields: {
                title: 'Title',
                new: 'New Chapter',
              },
            },
            questions: {
              title: 'Questions',
              empty: 'No questions',
              add_new: 'Add new question',
              new: 'New question',
              edit: 'Update',
              form: {
                title: 'Question title',
                local_questions: {
                  yes_no: 'Yes-No',
                  yes_no_nsp: 'Yes-No-NSP',
                  simple_choice: 'Simple Choice',
                  multiple_choice: 'Multiple Choice',
                  response: 'Response',
                  button_add: 'Add',
                },
              },
            },
            slides: {
              title: 'Slides',
              edit: 'Update',
              delete: 'Delete',
              button_show: {
                title: 'Show',
                less: 'less',
                more: 'more',
              },
            },
          },
        },
                polls: {
          label: 'Poll',
          title: 'Polls',
          helper_create_after_save: 'Polls will be created after the live is saved.',
          loading: 'Loading polls...',
          saving: 'Saving polls...',
          empty: 'No polls yet.',
          add: 'Add poll',
          add_first: 'Create first poll',
          add_hint: 'Open a new poll tab',
          tab_label: 'Poll {number}',
          untitled: 'Untitled poll',
          options_count: '{count} options',
          incomplete: 'Incomplete',
          editor_hint: 'Edit one poll at a time while keeping the full list visible above.',
          question_label: 'Question',
          question_placeholder: 'Enter poll question',
          publish_label: 'Posted automatically, visible to everyone.',
          option_label: 'Option {number}',
          option_placeholder: 'Enter option',
          add_option: 'Add option',
          existing_hint: 'Existing polls can now add, edit, and delete options before save.',
          delete_poll: 'Delete poll',
          delete_option: 'Delete option',
          confirm_delete_poll: 'Delete this poll?',
          confirm_delete_option: 'Delete this option?',
          min_options_warning: 'A poll needs at least 2 options.',
          delete_option_error: 'Unable to delete this poll option right now.',
          complete_current_first: 'Complete the current poll before adding a new one.',
          publish_error: 'Unable to update poll visibility right now.',
          validation_question_required: 'Question is required.',
          validation_min_options: 'Each poll needs at least 2 options.',
          validation_options_required: 'All poll options are required.',
        },
        presentation: {
          label: 'Presentation',
          loading: 'Loading presentations...',
          uploading: 'Uploading presentation...',
          deleting: 'Deleting presentation...',
          empty: 'No presentation yet.',
          upload: 'Upload document',
          formats_hint: 'PDF, PPTX, DOCX',
          refresh: 'Refresh',
          open: 'Open',
          delete: 'Delete',
          file: 'File',
          untitled: 'Untitled presentation',
          slides_count: '{count} slides',
          pending: 'Waiting for live save',
          helper_create_after_save: 'Save the live first to upload a presentation.',
          queued_success: 'Presentation added. It will be uploaded after the live is saved.',
          upload_success: 'Presentation uploaded successfully.',
          upload_error: 'Unable to upload the presentation right now.',
          fetch_error: 'Unable to load presentations right now.',
          delete_success: 'Presentation deleted successfully.',
          delete_error: 'Unable to delete this presentation right now.',
        },
        documents: {
          toggle_label: 'Shared files',
          title: 'Shared documents',
          empty: 'No shared documents yet.',
          upload: 'Select files to share',
          refresh: 'Refresh',
          delete: 'Delete',
          publish_default: 'Publish to the audience by default',
          pending: 'Waiting for live save',
          private: 'Private',
          public: 'Public',
          fichier:"File(s)",
          queued_success: 'Document added. It will be uploaded after the live is saved.',
          upload_success: 'Document uploaded successfully.',
          upload_error: 'Unable to upload this document right now.',
          fetch_error: 'Unable to load documents right now.',
          delete_success: 'Document deleted successfully.',
          delete_error: 'Unable to delete this document right now.',
          publish_error: 'Unable to update this document visibility right now.',
          uploaded_by: 'Added by',
          unpublish_all: 'Unpublish all for the audience',
          unpublish_all_success: 'All documents were unpublished for the audience.',
          unpublish_all_error: 'Unable to unpublish all documents right now.',
          unpublish_all_nothing: 'No documents to unpublish for the audience.',
          copy_link: 'Copy link',
          link_copied: 'Document link copied.',
          save_first: 'Save the live first to manage shared documents online.',
          visibility: 'Visible to the audience',
        },
        attaching_files: 'Attaching files',
        attaching_files_empreinte: 'Attached files',

      },
      frontOffice: {
        title: 'Front office parameters',
        access_page_direct:"Access to the live page",
        lecteur_video:"Video player",
        sous_titrage:"Subtitling",
        mdp:"Password",
        inscri_abonne:"Subscriber registration",
        options: {
          title: 'Options',
          subtitles_empreinte: 'Live subtitles',
          autoTranscription_empreinte:'Closed captions',
          chat_empreinte:"Chat Web",
          privateChat_empreinte:"Private chat",

          like: 'Like mention',
          subtitles: 'Real-time subtitles',
          autoTranscription:'Auto transcription',
          chat: 'Listener chat',
          privateChat: "Backstage",
          sharing_files: 'Shared files',
          sharing_files_live_event: { text: 'Visible on the Live Streaming page', explanation: '' },
          sharing_files_emails: 'Sent by email (link)',
          sharing_files_studio_live: { text: 'Available in the meeting', explanation: '' },
          social_media: {
            title: 'Social media',
            twitter: 'Twitter',
            fb: 'Facebook',
            wisembly: 'Wisembly',
            youtube: 'Youtube'
          },
          interactive_tools: {
            title: 'Interactive tools',
            whiteBoard: 'White Board',
            outils:"Tools",
            survey: 'Survey',
            question: 'Question',
            excel: 'Excel',
            autoSip: 'SIP call'
          },
          secure_pass: '\n' + 'Secure with password',
          registration: {
            title: '\n' + 'Registration of subscribers ',
            poll: 'Poll',
          },
          active_comment: {
            title: 'Q&A',
            confirm: 'With confirmation',
            replies: 'With answers',
            questionsBeforeLive: 'Questions before the live',
          },
        },
        configuration: {
          title: 'Configuration Front office',
          default: 'By default',
          personalized: {
            title: 'Personalized',
            title_before_live: 'Title (posted on the live page)',
            title_live: 'Live title',
            description: 'Description text',
            text: 'Text',
            description_before_live: 'Description (posted on the live page)',
            text_before_live: 'Text before live',
            message: {
              title: 'Message',
              description: 'Description (posted on the live page)',
            },
            video: {
              title: 'Video',
              description: 'Search...',
            },
            image: 'Image',
            countdown: 'Countdown',
            pearl: 'Encoding station',
          },
        },
      },



      Program: {
        title: 'Programmes & Intervenants',
        new_title:'Program',
        ParticpantsLimit: 'Limit of participants',
        LiveProgram: 'Live program',
        LiveProgramDescription: 'hh:mm - hh:mm \nSubject title and description',
        MaxParticipantsDistance: 'Max participants online',
        MaxInvited: 'Max participants on-site',
        Intervenants: 'Participants',
        AddParticipant: 'Add a participant',
        editParticipant: 'Edit a participant',
        Photo: 'Picture',
        Cliquez: 'Click to Upload',
        Nom: 'Last name',
        Prenom: 'First name',
        Fonction: 'Function',
        Structure: 'Structure',
        Email: 'Email',
        Annuler: 'Cancel',
        Ajouter: 'Add',
        Inscription: 'Inscription',
        Description: "Description",
        Role: "Role",
        options: {
          title: 'Options',
          like: "Mention j'aime",
          chat: 'Chat',
          sharing_files: 'Shared files',
          social_media: {
            title: 'Réseaux sociaux',
            twitter: 'Twitter',
            fb: 'Facebook',
            wisembly: 'Wisembly',
            youtube: 'Youtube'
          },
          secure_pass: 'Sécurisé avec mot de passe',
          registration: {
            title: 'Inscription des abonnés',
            poll: 'Sondage',
          },
          active_comment: {
            title: 'Q&A',
            confirm: 'Avec confirmation',
            replies: 'With replies',
            questionsBeforeLive: 'Questions before live',
          },
        },
        configuration: {
          title: 'Configuration Front office',
          default: 'Par défaut',
          personalized: {
            title: 'Personnalisé',
            title_before_live: 'Titre(affiché sur la page du direct)',
            title_live: 'Titre du direct',
            description: 'Texte de description',
            description_before_live: 'Description (affichée sur la page du direct)',
            text: 'Texte',
            text_before_live: 'Texte avant live',
            message: {
              title: 'Message',
              description: 'Message (affiché sur la page du direct)',
            },
            video: {
              title: 'Vidéo',
              description: 'Rechercher...',
            },
            image: 'Image',
            countdown: 'Comptes à rebours',
            pearl: "Station d'encodage",
          },
        },
      },
      SkinModel: {
        title: "Display Model",
        new_title:"Web Page",
        selectOrCreate: "Select an existing model or create a new one",
        choose: "Choose…",
        selectedSkin: "The applied model for this live is:",
        createNew: "Create a new model",
        existingSkins: "Created models",
        explanation: "You can reuse a model already used in another live.",
        newSkin: "Create a new model",
        primaryColor: "Primary color",
        secondaryColor: "Secondary color",
        primaryTextColor: "Primary text color",
        secondaryTextColor: "Secondary text color",
        liveTitle: "Title to display",
        logo: "Logo",
        beforeAfterInfo: "Before/After live info",
        beforeLiveInfo: "Before live info",
        afterLiveInfo: "After live info",
        infoText: "Text",
        showDate: "Show date",
        showHour: "Show hour",
        backgroundImage: "Background image",
        blurred: "Blurred",
        skinName: "Model name",
        addAndApply: "Apply",
        applySkin: "Edit",
        editNote:"Note: Modifying the model will affect the lives that use the same model."
      }

    },
  },
  upload_files: {
    title: 'Drag and drop',
    image_type: ' an image here',
    file_type: ' a file here',
    media_type: ' a media here',
    or: 'or ',
    click: 'click',
    selected_file: ' to select file from your computer',
  },
  vignette: {
    confirm: 'Confirm',
    edit: 'Update',
    delete: 'Delete',
    streaming_wrapper: 'LIVE STREAMING',
  },
  toast: {
    success_delete: 'Element successfully deleted!',
    success_add: 'Live successfully created!',
    success_edit: 'Live successfully updated!',
    success_diffusion: 'the broadcast was successful',
    error: 'An error occurred please try again!',
    success_send: 'Invitation was successfully sending!',
    success_send_link: 'Link was successfully sending!',
    success_download: 'Live was successfully downloaded!',
    'not-exist': "File does not exist!",
    no_emails_provided: 'No emails provided',
    no_date_provided: "No date provided",
    export_success: "File exported successfully",
    export_Error: "Error exporting Excel file",
    export_empty: "No existing data to export.",
    DeleteError: "Error occurred while deleting the participant",
    UpdateError: "Error occurred while updating the participant",
    AddError: "Error occurred while adding the participant",
    getModeratorsError: "Error occurred while getting the moderators",
    export_questions_success: "Questions exported successfully",
    no_questions_to_export: "No questions to export",
    export_questions_error: "Error occured while exporting questions",




  },
  date: {
    placeholder: 'Select a date',
  },
  statut: {
    Archive: "Archived",
    Live: "Live",
    Waiting: "Waiting",
    error: ""
  },

  startDirect: {
    title: 'Confirmation ',
    subtitle: "Do you want to start direct now ?",
    choix: 'Check this box to define this default choice and no longer display this window.',
    btn: {
      YES: 'YES',
      NO: 'NO'
    }
  },
  shareLink: {
    from: "From",
    to: "Send to ",
    selected: "Selected",
    link: "Link",
    password: "Password",
    secure_password: "Generate a secure password ",
    send_plan: "Schedule the shipment",
    planifier: "Schedule",
    date_plan: "The shipment will be scheduled on the specified date ",
    journalist: "Prompter",
    moderator: "Moderator",
    listener: "Listener",
    participant: "Participant",
    emails_placeholder: "Enter emails and press Enter",

  }
};



// WEBPACK FOOTER //
// ./src/i18n/en_US.js